'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './settings-edit-grid.routes';

export class SettingsEditGridComponent {
  constructor(SettingsService, Auth, $state, $stateParams, dialogs, Config, $timeout) {
    'ngInject';

    this.$timeout = $timeout;
    this.uneditableName = Config.getPlatformConfig().getSystemSettings();

    this.SettingsService = SettingsService;

    this.settingsId = $stateParams.id;

    this.dialogs = dialogs;
    this.$state = $state;

    var populateTable = () => {
      this.colDefs.push({
        name: 'Actions',
        enableSorting: false,
        enableCellEdit: false,
        width:60,
        cellTemplate:'<nobr><a class="btn btn-xs btn-primary" ng-click="grid.appScope.insertAfter(row)"><i class="fa fa-fw fa-plus"></i></a>' +
          '&nbsp;' +
          '<a class="btn btn-xs btn-danger" ng-click="grid.appScope.deleteRow(row)"><i class="fa fa-fw fa-trash"></i></a></nobr>'
      });

      this.gridOptions = {
        enableSorting: true,
        enableCellEditOnFocus: true,
        //enableRowSelection: true,
        //enableSelectAll: true,
        columnDefs: this.colDefs,
        data: this.settings.data,
        onRegisterApi: (gridApi) => {
          this.gridApi = gridApi;
          window.gridApi = this.gridApi;
        },
        appScopeProvider: this
      };
    };

    if (this.settingsId) {
      this.SettingsService.get({id: this.settingsId}, data => {
        this.settings = data;
        this.colDefs = [];

        let tableConfigSetting = this.settings.name.split('-data')[0] + "-table-config";

        console.log(tableConfigSetting);

        this.SettingsService.getByName({name: tableConfigSetting}, tblConfigData => {

          let clmns = tblConfigData.data.columns;

          for (let i=0; i<clmns.length; i++) {
            this.colDefs.push({name: clmns[i], field: i.toString(), cellEditableCondition:true});
          }

          populateTable();

        }, err => {
          for (let i=0; i<this.data[0].length; i++) {
            this.colDefs.push({name: 'Column '+(i+1), field: i.toString(), cellEditableCondition:true});
          }
          populateTable();
        });

      }, err => {
        console.log('Could not load settings from server');
      })
    }

  }

  deleteRow(row) {
    var index = this.gridOptions.data.indexOf(row.entity);
    this.gridOptions.data.splice(index, 1);
  };

  insertAfter(row) {
    var index = this.gridOptions.data.indexOf(row.entity);
    this.gridOptions.data.splice(index+1, 0, ['','']);
  }

  hasUneditableName(name) {
    return this.uneditableName.indexOf(name) !== -1;
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The data has been saved successfully");
        dlg.result.then(() => {
          that.$state.go("settings-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.settingsId) {  // Save changes on the current settings
        this.SettingsService.update({id: this.settingsId}, this.settings, onSuccess, onError);
      } else { // Create new settings
        this.SettingsService.save(this.settings, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.ap.settings.editGrid', [uiRouter])
  .config(routes)
  .component('settingsEditGrid', {
    template: require('./settings-edit-grid.html'),
    controller: SettingsEditGridComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/settings/edit-grid/settings-edit-grid.component.js